<template>
<BaseTableWrapper>
  <template #top-buttons></template>
  <template #filtering></template>
  <template #body>
    <Loader v-if="false"></Loader>
    <table v-else class="table table-sm table-striped table-hover">
      <thead>
      <tr>
        <th>{{$t('views.financialreport.list.contractor')}}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in firms" :key="item.id">
        <td>
          <router-link
            v-if="item.isCompany === 1"
            :to="{
              name:'FirmShow',
              params: {id: item['@id'] }
            }"
          >
            {{ item.firmname1 }}
          </router-link>
          <router-link
            v-else
            :to="{
              name:'UserDataShow',
              params: {id: item['@id'] }
            }"
          >
            {{ item.fullName }}
          </router-link>
        </td>
        <td>
          <router-link
            tag="button"
            :to="{name: 'FinancialReportShow', params: {id: getId(item['@id'])}}"
            class="btn btn-link fa fa-search fa-lg"
          ></router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </template>
</BaseTableWrapper>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'List',
  components: {
    BaseTableWrapper,
    Loader
  },
  computed: {
    ...mapGetters({
      firms: 'financialreport/list/firms'
    })
  },
  created () {
    this.fetchFirms()
  },
  methods: {
    getId (iri) {
      return getId(iri)
    },
    ...mapActions({
      fetchFirms: 'financialreport/list/fetchFirms'
    })
  }
}
</script>

<style scoped>

</style>
